import { DictionaryContent } from "../../components/configuration";

export default function Dictionary() {
  return (
    <>
      <DictionaryContent />
    </>
  );
}
